import Loading from "@/components/Loading";
import AdminLayout from "@/layout/AdminLayout";
import React from "react";
import {PAGE_URL} from "../services/constant";
const ReferralReward = React.lazy(() =>
    import('../ReferralReward')
);
const referralRewardRoutesRegistry = [
    {
        path: PAGE_URL.REFERRAL_REWARD_PAGE,
        element: <ReferralReward />,
        loading: <Loading />,
        layout: AdminLayout,
    },
];

export default referralRewardRoutesRegistry;
